import { render } from "./CruAks.vue?vue&type=template&id=f57e73d0&scoped=true&ts=true"
import script from "./CruAks.vue?vue&type=script&lang=ts"
export * from "./CruAks.vue?vue&type=script&lang=ts"

import "./CruAks.vue?vue&type=style&index=0&id=f57e73d0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f57e73d0"]])

export default __exports__